import { Logger } from './logging-types';
import { sLog } from './log';
import { cLog } from './client-logging';

/**
 * 统一的日志接口，自动根据运行环境选择合适的日志实现
 * 在服务端使用 pino，在客户端使用 DataDog browser logs
 */
export function getLogger(): Logger {
  if (typeof window === 'undefined') {
    // 服务端环境
    return sLog();
  } else {
    // 客户端环境
    return cLog();
  }
}

/**
 * 便捷的日志函数，可以直接使用
 */
export const logger = {
  debug: (msg: string, obj?: object) => getLogger().debug(msg, obj),
  info: (msg: string, obj?: object) => getLogger().info(msg, obj),
  warn: (msg: string, obj?: object) => getLogger().warn(msg, obj),
  error: (msg: string, obj?: object) => getLogger().error(msg, obj),
} as const;
